// src/services/ultra-private-key-vault.service.ts

const ULTRA_PRIVATE_KEY_VAULT = "lrnsy_ultra_private_key_vault_v1";

type VaultRecord = {
  key: string;
  createdAt: number;
};

type Vault = Record<string, VaultRecord>;

class UltraPrivateKeyVaultService {
  private readVault(): Vault {
    try {
      const raw = sessionStorage.getItem(ULTRA_PRIVATE_KEY_VAULT);
      if (!raw) return {};
      return JSON.parse(raw) as Vault;
    } catch {
      return {};
    }
  }

  private writeVault(vault: Vault) {
    try {
      sessionStorage.setItem(ULTRA_PRIVATE_KEY_VAULT, JSON.stringify(vault));
    } catch {
      // Silent by design. Ultra Private can still work if the key remains in the immediate link.
    }
  }

  saveKey(cardId: string, key: string) {
    if (!cardId || !key) return;

    const vault = this.readVault();

    vault[cardId] = {
      key,
      createdAt: Date.now(),
    };

    this.writeVault(vault);
  }

  getKey(cardId: string): string | null {
    if (!cardId) return null;

    const vault = this.readVault();
    return vault[cardId]?.key || null;
  }

  removeKey(cardId: string) {
    const vault = this.readVault();
    delete vault[cardId];
    this.writeVault(vault);
  }

  buildRecipientLink(params: {
    appUrl: string;
    shareableToken: string;
    cardId: string;
    privacyMode?: string | null;
  }) {
    const baseLink = `${params.appUrl}/recipient/${params.shareableToken}`;

    if (params.shareableToken.includes("#key=")) {
      return `${params.appUrl}/recipient/${params.shareableToken}`;
    }

    if (params.privacyMode !== "ultra_private") {
      return baseLink;
    }

    const key = this.getKey(params.cardId);
    if (!key) return baseLink;

    return `${baseLink}#key=${encodeURIComponent(key)}`;
  }
}

export const ultraPrivateKeyVaultService = new UltraPrivateKeyVaultService();
